import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.742 4.5c1.36-1.153 3.444-.184 3.444 1.597V18.07c0 1.78-2.083 2.749-3.444 1.596l-3.675-3.114H4.092A2.09 2.09 0 0 1 2 14.459V9.707c0-1.155.937-2.092 2.092-2.092h1.975zm1.261 1.793L7.173 9.54a1.1 1.1 0 0 1-.706.259H4.183v4.57h2.284c.259 0 .509.092.706.26l3.83 3.245zM21.95 9a1.09 1.09 0 0 1 0 1.543l-1.479 1.48 1.48 1.48a1.092 1.092 0 0 1-1.544 1.543l-1.479-1.48-1.48 1.48a1.091 1.091 0 1 1-1.542-1.544l1.479-1.479-1.48-1.48A1.092 1.092 0 0 1 17.449 9l1.479 1.48L20.407 9a1.09 1.09 0 0 1 1.542 0",
      class: "hidden joe-be:block joe:block qmusic:block"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M1 15.386V8.052h4.89L12 1.942v19.554l-6.11-6.11zm19.748.4 1.418-1.419-2.648-2.648 2.648-2.648-1.418-1.418L18.1 10.3l-2.65-2.649-1.417 1.418 2.649 2.649-2.65 2.649 1.42 1.418 2.648-2.649z",
      class: "hidden willy:block",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }